import axios from 'axios';

export const HTTPSPA = axios.create({
  baseURL: `https://www.la3btna.com/La3btnaAPIs/APIs/`
})
